import React, { useState } from "react";
import { AppBar, Toolbar, Box, Button, CssBaseline, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Divider } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/HelpOutline';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';

const AppBarModule = ({ title, menuOptions, onNewClick, onClose,menuList }) => {
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState(title || 'All Project');
    const openFirst = Boolean(anchorElFirst);

    const [anchorElSecond, setAnchorElSecond] = useState(null);
    const openSecond = Boolean(anchorElSecond);


    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option);
        handleMenuCloseFirst();
        menuList(option);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };
    const handleMenuItemClickSecond = (option) => {
        // setSelectedOptionSecond(option); // Update the selected option
    };

    return (
        <Box sx={{ marginTop: "0px" }}>
            <CssBaseline />
            <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                <Toolbar>
                    {/* Dynamic Title Menu */}
                    <Button
                        color="inherit"
                        onClick={handleMenuClickFirst}
                        endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                            sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                    >
                        {selectedOptionFirst}
                    </Button>
                    <Menu anchorEl={anchorElFirst} open={openFirst} onClose={handleMenuCloseFirst}>
                        {menuOptions.map((option, index) => (
                            <MenuItem key={index} onClick={() => handleMenuItemClickFirst(option)}>
                                {option}
                            </MenuItem>
                        ))}
                    </Menu>

                    {/* New Button */}
                    {onNewClick && (
                        <Button
                            size="small"
                            variant="contained"
                            color="secondary"
                            startIcon={<AddIcon sx={{ fontSize: "18px" }} />}
                            sx={{ marginLeft: 'auto', textTransform: 'none' }}
                            onClick={onNewClick}
                        >
                            New
                        </Button>
                    )}

                    <IconButton
                        size="small"                        
                        aria-label="menu"
                        sx={{ ml: 2 }}
                        onClick={handleMenuClickSecond}
                    >
                        <MoreVertIcon sx={{ fontSize: "18px" }} />
                    </IconButton>

                    <Menu
                        anchorEl={anchorElSecond}
                        open={openSecond}
                        onClose={handleMenuCloseSecond}
                    >
                        <MenuItem onClick={() => handleMenuItemClickSecond('Import Shift')}>
                            <ListItemIcon>
                                <ImportExportIcon />
                            </ListItemIcon>
                            <ListItemText primary="Import Shift" />
                        </MenuItem>
                        <MenuItem onClick={() => handleMenuItemClickSecond('Export Shift')}>
                            <ListItemIcon>
                                <FileDownloadIcon />
                            </ListItemIcon>
                            <ListItemText primary="Export Vendors" />
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                            <ListItemIcon>
                                <ViewColumnIcon />
                            </ListItemIcon>
                            <ListItemText primary="Export Current View" />
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                            <ListItemIcon>
                                <ListAltIcon />
                            </ListItemIcon>
                            <ListItemText primary="Preference " />
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                            <ListItemIcon>
                                <RefreshIcon />
                            </ListItemIcon>
                            <ListItemText primary="Refresh List" />
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>

                            <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                Reset Columns Width
                            </Button>
                        </MenuItem>
                    </Menu>

                    {/* Help Icon */}
                    <IconButton size="small" sx={{ ml: 2 }}>
                        <HelpIcon sx={{ fontSize: "18px" }} />
                    </IconButton>

                    {/* Close Button */}
                    {onClose && (
                        <IconButton size="small" onClick={onClose}>
                            <CloseIcon sx={{ fontSize: "18px",color: "#2196F3"  }}  />
                        </IconButton>
                    )}
                </Toolbar>
            </AppBar>
        </Box>
    );
};

export default AppBarModule;
